import { Plus } from 'components';

const Add = props => {
  const { color, bgColor } = props;

  return <Plus color={color} bgColor={bgColor} />;
};

export { Add };